export const PAYMENT_TYPES = {
  BONUS_CASH: 'BONUS_CASH',
  CREDIT_CARD: 'CREDIT_CARD',
  ACCOUNT_TRANSFER: 'ACCOUNT_TRANSFER',
  VIRTUAL_ACCOUNT: 'VIRTUAL_ACCOUNT',
  AUTOMATIC_PAYMENT_BY_CREDIT_CARD: 'AUTOMATIC_PAYMENT_BY_CREDIT_CARD',
  AUTOMATIC_PAYMENT_BY_ACCOUNT_TRANSFER: 'AUTOMATIC_PAYMENT_BY_ACCOUNT_TRANSFER',
};

export const USER_READABLE_PAYMENT_TYPES = {
  BONUS_CASH: '보너스캐시',
  CREDIT_CARD: '신용카드',
  ACCOUNT_TRANSFER: '계좌이체',
  VIRTUAL_ACCOUNT: '가상계좌',
  AUTOMATIC_PAYMENT_BY_CREDIT_CARD: '신용카드 자동결제',
  AUTOMATIC_PAYMENT_BY_ACCOUNT_TRANSFER: '계좌이체 자동결제',
  CLASSIC_AUTOMATIC_PAYMENT_BY_DACOMCARD: '신용카드 자동결제(LG U+)',
  CLASSIC_AUTOMATIC_PAYMENT_BY_INICARD: '신용카드 자동결제(이니시스)',
};

export const PURCHASE_TYPES = {
  PAID: 'PAID',
  COUPON: 'COUPON',
  OWNERSHIP_TRANSFER: 'OWNERSHIP_TRANSFER',
  FREE: 'FREE',
  COMPENSATED: 'COMPENSATED',
};

export const PAY_TOOL_NAME = {
  AUTOMATIC_PAYMENT_BY_CREDIT_CARD: '신용카드 자동결제',
  AUTOMATIC_PAYMENT_BY_ACCOUNT_TRANSFER: '계좌이체 자동결제',
  CLASSIC_AUTOMATIC_PAYMENT_BY_DACOMCARD: '신용카드 자동결제(LG U+)',
  CLASSIC_AUTOMATIC_PAYMENT_BY_INICARD: '신용카드 자동결제(이니시스)',
};
